export const colors = {
  black: '#000',
  white: '#FFF',
  fill: {
    coral: '#FA7C4E',
    blue: '#237CBC',
    purple: '#4D55B9',
    green: '#639e28',
    yellow: '#ffbf00',
    orange: '#ff9400',
    red: '#E02828',
    grey: '#696969',
  }, 
  divider: {
    coral: '#FFDBCE',
    blue: '#CAEFFF',
    purple: '#D5DFFF',
    green: '#DDEECC',
    grey: '#F1F1F1',
    orange: '#ffe4bf',
    yellow: '#ffeaa9',
    red: '#F5DADA',
  },
  background: {
    coral: '#FFF7F4',
    blue: '#EFF8FF',
    purple: '#EAEFFF',
    grey: '#FBFBFB',
    green: '#eafad5',
    red: '#fff0f0',
    white: '#FFF',
    orange: '#fff1de',
    yellow: '#fff7e0',
    component: {
      grey: '#F2F2F2',
    }
  },
  text: {
    medium:  {
      grey: '#696969',
      red: '#E02828',
      orange: '#ff9400',
      coral: '#FA7C4E',
      blue: '#237CBC',
      purple: '#4D55B9',
      green: '#639e28',
      yellow: '#ffbf00',
    },
    dark:  {
      grey: '#333333',
    }, 
    light: {
      grey: '#BFBDBD',
      blue: '#80b7cf',
      purple: '#9b9bd1',
      green: '#8bc34a',
    },
    disable: {
      grey: '#F2F2F2',
      coral: '#FFF1EC'
    }
  },
};